import React, {Component} from 'react';
import TaskGroupReportFilteredList from './TaskGroupReportFilteredList';

export default class TaskGroupReportContainer extends Component{

    render() {
        return <TaskGroupReportFilteredList/>
    }
}